import React from 'react'

import TopAppBar from './TopAppBar';
import AppDrawer from './AppDrawer';
import GridMenu  from './GridMenu';

import {useState, useRef} from 'react'
import { makeStyles } from '@material-ui/styles';
import CheckOutButtons from './CheckOutButtons';
import  FeaturedCard  from './FeaturedCard';
import WhatsAppCard from './WhatsAppCard';
import Footer from './Footer';

import {hasItemServices} from '../hooks/item-services'



const useStyles = makeStyles((theme) => ({
  root:{
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    minHeight:"100vh",
   // backgroundColor: 'blue'
  },

}));

const getCounterBacket=(list)=>{
  let counter =0; 
  list.forEach(element => {
        counter+=element.count; 
  });
  return counter; 
}


const getFeatures = (list)=>{
    let features={
      main:undefined, 
      list:[]
    }; 
  
    if(!list || list.length===0){  
      return features; 
    }

   
   features.main=list[0]; 
   
   for(let i=1; i<list.length; i++ ){
     const l= list[i];
     features.list.push(l);  
   }


  return features;
}




export default function StorePage(props) {
 
  const classes = useStyles();
  const {location, order, setLocation, strings, onCheckout,isTakingOrder,onOrderAddItemAdditions} = props; 
  const [openDrawer, setOpenDrawer] = useState(false);
 
  //console.debug('location',location); 
  const hasServices= hasItemServices(location); 
  const list = order ? order.list : []; 
  const counter = hasServices? 0 : getCounterBacket(list); 
  const [basket, setBasket] = useState(counter);
  const [orderList, setOrderList] = useState(list);
  const refList = useRef(!list ? []: list);
  const containersSize = location.containers.length; 
  const isActiveyWhatsApp = location.takeorder?.whatsapp?.active;
  const features = getFeatures(location.features); 

  const deliveryPath = location.storeUrl; 

  const handleDrawerOpen = () => {
    console.log('Open Drawer')
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const handlerOnDrawerItemClick=(id)=>{   
    let current= location.containers.find(item => item.id===id);     
    let newLocation=location; 
    newLocation.current=current;    
    setLocation(newLocation); 
    scrollToTop(); 

  }

  const scrollToTop = ()=>{
    setTimeout(()=> {
      const element = document.getElementById('topAppBar');
     // console.debug('storePage: element',element);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
   }
   ,300);
  }

  const handlerOrderChange=(list,item)=>{
    const counter = getCounterBacket(list); 
    refList.current=list;
    setOrderList(list); 
    

    if(hasServices){
      if(item && item.type==="DELIVERY_SERVICE"){
        //console.debug('storePage: handlerOrderChange Checkout');
        onCheckout(refList.current);
      }
      return; 
    }
   
    setBasket(counter); 
    //console.debug('storePage: handlerOrderChange list:', list);
  }

  const handlerClickCheckout=()=>{
    //console.debug('handlerClickCheckout');
    onCheckout(refList.current);
  }

  const handlerClickMessage=()=>{
    //console.debug('handlerClickMessage');
  }
    


    return (
        <div className={classes.root}   id={"topAppBar"} >  
          <TopAppBar 
          
              onClickNavigation={handleDrawerOpen} 
              title = {location.name} 
              basket={basket} 
              size = {containersSize}
              strings = {strings}
              onClickCheckout={handlerClickCheckout}/>
          <AppDrawer 
              open={openDrawer}
              onClickClose={handleDrawerClose}
                location ={location} 
                onItemClick={handlerOnDrawerItemClick} />

          <div>
          { !isTakingOrder && isActiveyWhatsApp && 
            
            <WhatsAppCard
              title = "Delivery"
              subtitle={strings.delivery_go_to_webapp}
              onClick={()=> window.open(deliveryPath)}
            />
          }

          { features.main && 
              <FeaturedCard
                textAlign={features.main.content.textAlign}
                title={features.main.content.title}
                subtitle={features.main.content.subtitle}
                image={features.main.content.image}
              />
          }
        
          <GridMenu 
              current={location.current}
              onOrderListChange = {handlerOrderChange}
              orderList= {orderList}
              setOrderList={setOrderList}
              currency={location.currency}
              onClickViewMore= {containersSize>1?handleDrawerOpen: null}
              labelViewMore = {strings.action_view_more}
              isTakingOrder={isTakingOrder}
              strings = {strings}
              locationType={location.type}
              onOrderAddItemAdditions={onOrderAddItemAdditions}
          />

          {
            !isTakingOrder &&  features.list.map( (feature)=>
                  <FeaturedCard
                  key={feature.uid}
                  textAlign={feature.content.textAlign}
                  title={feature.content.title}
                  subtitle={feature.content.subtitle}
                  image={feature.content.image}
                  />
              ) 
          }
          { 
            <Footer
              isTakingOrder={isTakingOrder}
              location = {location}
              linkMessage={strings.powered_by}
              padding = {basket>0}
            />
          }
          
          </div> 
          <div>
            {    basket>0 && 
                  <CheckOutButtons
                  basket = {basket}
                  onClickMessage={handlerClickMessage}
                  onClickNext={handlerClickCheckout}
                  labelMessage={strings.action_cancel}
                  labelNext={strings.action_order}
                  />
            }
          </div>
      </div>
    )
}
